const hasNotes = (notes) => {
  return {
    getDefaultNote() {
      const index = notes.findIndex(note => note.isDefault);
      return index === -1 ? '' : notes[index].noteNumber;
    },

    getFormattedNotes() {
      return notes.map((note) => {
        const formatted = {
          label: note.label,
          note,
        };
        if (note.isDefault) {
          formatted.isDefault = true;
        }
        return formatted;
      });
    },
    getNotesWithAdded(note) {
      if (!notes.length) {
        return [{ ...note, isDefault: true }];
      }
      return [{ ...note, isDefault: false }, ...notes];
    },
    getNotesWithDefault(defaultIndex) {
      return notes.map((note, index) => {
        if (index === defaultIndex) {
          return { ...note, isDefault: true };
        }
        return { ...note, isDefault: false };
      });
    },
    getNotesWithDeleted(index) {
      const withDeleted = [...notes];
      withDeleted.splice(index, 1);
      return withDeleted;
    },
    getNotesWithUpdated(index, note) {
      const withUpdated = [...notes];
      withUpdated.splice(index, 1, note);
      return withUpdated;
    },
  };
};

export default hasNotes;
